import { Text } from '@lucidhq/lucidium';
import { ReactNode } from 'react';

export interface NoDataScreenProps {
  noDataComponent?: ReactNode;
}

export const NoDataScreen = ({ noDataComponent }: NoDataScreenProps) =>
  (noDataComponent && <>{noDataComponent}</>) || (
    <Text
      lss={{
        textScale: 'control',
        textAlign: 'center',
        mb: 'lg',
        mt: 'lg',
      }}
    >
      Could not find data associated with this search and/or filters
    </Text>
  );
